// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-settings-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.admin-settings-container {
  display: flex;
  min-height: 100vh;
}

/* 사이드바 스타일 */
.admin-sidebar {
  width: 250px;
  background-color: #ffffff;
  border-right: 1px solid #e0e0e0;
  min-height: 100vh;
}

.sidebar-menu {
  padding: 20px;
}

.sidebar-menu h3 {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.sidebar-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu ul li {
  padding: 12px 0;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.sidebar-menu ul li:hover {
  color: #e84118;
}

.sidebar-menu ul li.active {
  color: #e84118;
  font-weight: 600;
  background-color: #fff5f3;
  padding-left: 10px;
  margin-left: -10px;
  border-left: 3px solid #e84118;
}

/* 메인 컨텐츠 영역 */
.admin-content {
  flex: 1 1;
  padding: 30px;
  background-color: #ffffff;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e84118;
}

.content-header h2 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.save-success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 10px 15px;
  border-radius: 4px;
  border: 1px solid #c3e6cb;
  font-size: 14px;
}

.settings-description {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 30px;
  border-left: 4px solid #e84118;
}

.settings-description p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

/* 폼 스타일 */
.settings-form {
  max-width: 1000px;
}

.settings-section {
  margin-bottom: 40px;
}

.settings-section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  color: #333;
}

.settings-form-table {
  width: 100%;
  border-top: 2px solid #333;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.settings-form-table tr {
  border-bottom: 1px solid #ddd;
}

.settings-form-table th,
.settings-form-table td {
  padding: 15px;
  text-align: left;
  vertical-align: middle;
}

.settings-form-table th {
  background-color: #f8f9fa;
  font-weight: bold;
  width: 200px;
  border-right: 1px solid #ddd;
}

.settings-form-table td {
  background-color: #fff;
}

/* 입력 필드 스타일 */
.settings-form-table input[type="text"],
.settings-form-table input[type="email"],
.settings-form-table input[type="password"],
.settings-form-table select,
.settings-form-table textarea {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.input-small {
  width: 100px;
}

.input-medium {
  width: 300px;
}

.input-large {
  width: 100%;
  max-width: 600px;
}

/* 토글 스위치 스타일 */
.maintenance-toggle-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toggle-input {
  display: none;
}

.toggle-label {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  background-color: #ccc;
  border-radius: 13px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle-input:checked + .toggle-label {
  background-color: #e84118;
}

.toggle-button {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 22px;
  height: 22px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

.toggle-input:checked + .toggle-label .toggle-button {
  transform: translateX(24px);
}

/* 이미지 업로드 스타일 */
.image-upload-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.file-input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-input {
  display: none;
}

.file-input-label {
  padding: 10px 20px;
  background-color: #e84118;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.file-input-label:hover {
  background-color: #d63801;
}

.image-preview {
  max-width: 300px;
}

.image-preview p {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #333;
}

.image-preview img {
  max-width: 100%;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
}

/* 버튼 스타일 */
.form-bottom-actions {
  text-align: center;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #ddd;
}

.btn-save {
  background-color: #e84118;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-save:hover:not(:disabled) {
  background-color: #d63801;
}

.btn-save:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* 로딩 및 에러 스타일 */
.loading, .error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 16px;
}

.error {
  color: #dc3545;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
  .admin-settings-container {
    flex-direction: column;
  }
  
  .admin-sidebar {
    width: 100%;
    min-height: auto;
  }
  
  .admin-content {
    padding: 20px;
  }
  
  .settings-form-table th {
    width: 150px;
  }
  
  .input-large {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .content-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .settings-form-table {
    display: block;
  }
  
  .settings-form-table tr {
    display: block;
    margin-bottom: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
  }
  
  .settings-form-table th,
  .settings-form-table td {
    display: block;
    width: 100%;
    border: none;
    padding: 5px 0;
  }
  
  .settings-form-table th {
    background-color: transparent;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .input-medium,
  .input-large {
    width: 100%;
  }
}

/* 발주서 샘플 파일 관리 스타일 */
.current-file-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.file-name {
  font-size: 14px;
  color: #333;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.file-actions {
  display: flex;
  gap: 8px;
}

.btn-download,
.btn-delete,
.btn-upload {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-download {
  background-color: #28a745;
  color: white;
}

.btn-download:hover {
  background-color: #218838;
}

.btn-delete {
  background-color: #dc3545;
  color: white;
}

.btn-delete:hover {
  background-color: #c82333;
}

.btn-delete:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn-upload {
  background-color: #007bff;
  color: white;
}

.btn-upload:hover {
  background-color: #0056b3;
}

.btn-upload:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.no-file {
  color: #666;
  font-style: italic;
}

.file-upload-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.file-input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-help-text {
  color: #666;
  font-size: 12px;
  margin-top: 5px;
}

/* 파비콘 관리 스타일 */
.favicon-management-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.favicon-upload-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.favicon-preview-section {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.favicon-preview {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
}

.favicon-preview img {
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 2px;
  background-color: white;
}

.favicon-info {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.upload-button {
  padding: 8px 16px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.upload-button:hover {
  background-color: #218838;
}

.upload-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.delete-button {
  padding: 6px 12px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s;
}

.delete-button:hover {
  background-color: #c82333;
}

.delete-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
} `, "",{"version":3,"sources":["webpack://./src/admin/css/AdminSettingsPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".admin-settings-page {\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.admin-settings-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* 사이드바 스타일 */\n.admin-sidebar {\n  width: 250px;\n  background-color: #ffffff;\n  border-right: 1px solid #e0e0e0;\n  min-height: 100vh;\n}\n\n.sidebar-menu {\n  padding: 20px;\n}\n\n.sidebar-menu h3 {\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.sidebar-menu ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-menu ul li {\n  padding: 12px 0;\n  color: #666;\n  cursor: pointer;\n  font-size: 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.sidebar-menu ul li:hover {\n  color: #e84118;\n}\n\n.sidebar-menu ul li.active {\n  color: #e84118;\n  font-weight: 600;\n  background-color: #fff5f3;\n  padding-left: 10px;\n  margin-left: -10px;\n  border-left: 3px solid #e84118;\n}\n\n/* 메인 컨텐츠 영역 */\n.admin-content {\n  flex: 1;\n  padding: 30px;\n  background-color: #ffffff;\n}\n\n.content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e84118;\n}\n\n.content-header h2 {\n  color: #333;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.save-success-message {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 10px 15px;\n  border-radius: 4px;\n  border: 1px solid #c3e6cb;\n  font-size: 14px;\n}\n\n.settings-description {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 5px;\n  margin-bottom: 30px;\n  border-left: 4px solid #e84118;\n}\n\n.settings-description p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* 폼 스타일 */\n.settings-form {\n  max-width: 1000px;\n}\n\n.settings-section {\n  margin-bottom: 40px;\n}\n\n.settings-section-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ddd;\n  color: #333;\n}\n\n.settings-form-table {\n  width: 100%;\n  border-top: 2px solid #333;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.settings-form-table tr {\n  border-bottom: 1px solid #ddd;\n}\n\n.settings-form-table th,\n.settings-form-table td {\n  padding: 15px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.settings-form-table th {\n  background-color: #f8f9fa;\n  font-weight: bold;\n  width: 200px;\n  border-right: 1px solid #ddd;\n}\n\n.settings-form-table td {\n  background-color: #fff;\n}\n\n/* 입력 필드 스타일 */\n.settings-form-table input[type=\"text\"],\n.settings-form-table input[type=\"email\"],\n.settings-form-table input[type=\"password\"],\n.settings-form-table select,\n.settings-form-table textarea {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.input-small {\n  width: 100px;\n}\n\n.input-medium {\n  width: 300px;\n}\n\n.input-large {\n  width: 100%;\n  max-width: 600px;\n}\n\n/* 토글 스위치 스타일 */\n.maintenance-toggle-container {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.toggle-switch {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.toggle-input {\n  display: none;\n}\n\n.toggle-label {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n  background-color: #ccc;\n  border-radius: 13px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.toggle-input:checked + .toggle-label {\n  background-color: #e84118;\n}\n\n.toggle-button {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 22px;\n  height: 22px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.toggle-input:checked + .toggle-label .toggle-button {\n  transform: translateX(24px);\n}\n\n/* 이미지 업로드 스타일 */\n.image-upload-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.file-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.file-input {\n  display: none;\n}\n\n.file-input-label {\n  padding: 10px 20px;\n  background-color: #e84118;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.file-input-label:hover {\n  background-color: #d63801;\n}\n\n.image-preview {\n  max-width: 300px;\n}\n\n.image-preview p {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: #333;\n}\n\n.image-preview img {\n  max-width: 100%;\n  height: auto;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n/* 버튼 스타일 */\n.form-bottom-actions {\n  text-align: center;\n  margin-top: 40px;\n  padding-top: 30px;\n  border-top: 1px solid #ddd;\n}\n\n.btn-save {\n  background-color: #e84118;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.btn-save:hover:not(:disabled) {\n  background-color: #d63801;\n}\n\n.btn-save:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* 로딩 및 에러 스타일 */\n.loading, .error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  font-size: 16px;\n}\n\n.error {\n  color: #dc3545;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 1024px) {\n  .admin-settings-container {\n    flex-direction: column;\n  }\n  \n  .admin-sidebar {\n    width: 100%;\n    min-height: auto;\n  }\n  \n  .admin-content {\n    padding: 20px;\n  }\n  \n  .settings-form-table th {\n    width: 150px;\n  }\n  \n  .input-large {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .content-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n  }\n  \n  .settings-form-table {\n    display: block;\n  }\n  \n  .settings-form-table tr {\n    display: block;\n    margin-bottom: 15px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px;\n  }\n  \n  .settings-form-table th,\n  .settings-form-table td {\n    display: block;\n    width: 100%;\n    border: none;\n    padding: 5px 0;\n  }\n  \n  .settings-form-table th {\n    background-color: transparent;\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .input-medium,\n  .input-large {\n    width: 100%;\n  }\n}\n\n/* 발주서 샘플 파일 관리 스타일 */\n.current-file-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.file-name {\n  font-size: 14px;\n  color: #333;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.file-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-download,\n.btn-delete,\n.btn-upload {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-download {\n  background-color: #28a745;\n  color: white;\n}\n\n.btn-download:hover {\n  background-color: #218838;\n}\n\n.btn-delete {\n  background-color: #dc3545;\n  color: white;\n}\n\n.btn-delete:hover {\n  background-color: #c82333;\n}\n\n.btn-delete:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.btn-upload {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-upload:hover {\n  background-color: #0056b3;\n}\n\n.btn-upload:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.no-file {\n  color: #666;\n  font-style: italic;\n}\n\n.file-upload-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.file-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.file-help-text {\n  color: #666;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n/* 파비콘 관리 스타일 */\n.favicon-management-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.favicon-upload-section {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.favicon-preview-section {\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 5px;\n  border: 1px solid #e0e0e0;\n}\n\n.favicon-preview {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.favicon-preview img {\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 2px;\n  background-color: white;\n}\n\n.favicon-info {\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 5px;\n  border: 1px solid #e0e0e0;\n}\n\n.upload-button {\n  padding: 8px 16px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.upload-button:hover {\n  background-color: #218838;\n}\n\n.upload-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.delete-button {\n  padding: 6px 12px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background-color 0.3s;\n}\n\n.delete-button:hover {\n  background-color: #c82333;\n}\n\n.delete-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
